import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function MwaliIBC() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Mwali IBC (International Business Company)</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Offshore Company Incorporation in Mohéli, Comoros</h3>
                            <p className='page-paragraph'>
                                A <b>Mwali IBC</b> is a fast, flexible, and low-cost offshore vehicle under the <b>Mwali International Services Authority (MISA).</b> It is recognized globally as part of the <b>Comoros Union framework,</b> making it attractive for entrepreneurs in <b>brokerage, forex, crypto, gaming, and general offshore business.</b>
                            </p>
                            <p className='page-paragraph'>
                                While recognition is not as high as Tier-1 jurisdictions, Western Sahara IBCs are often used by businesses seeking speed, <b>flexibility, and minimal costs.</b>
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Fast Setup",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Affordable",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Multi-Purpose",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "License Compatible",
                                        icon: TiTick,
                                    },
                                ]}
                            />



                            <Button
                                text="Request a Mwali IBC Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />

                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Choose a Mwali IBC?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Popularity",
                                    paragraph: "Widely used by forex & fintech operators",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Low Cost",
                                    paragraph: "Cheaper than Malta, Cyprus, or Isle of Man",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Use",
                                    paragraph: "Standalone IBC or combined with licenses",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy",
                                    paragraph: "Shareholders & directors not on public record",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Startup-Friendly",
                                    paragraph: "Fast-track setup with low annual costs",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Key Features of a Mwali IBC</h3>
                        <PageList
                            items={[
                                {
                                    title: "100% foreign ownership allowed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No minimum capital requirement",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "At least 1 shareholder & 1 director",
                                    paragraph: "(individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local registered agent & office required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Share capital can be denominated in any currency",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Confidentiality protected by Mwali corporate law",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Recognized as part of the Comoros Union",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Benefits of Mwali IBC
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Tax Neutrality — no corporate tax on offshore activities.",
                                },
                                {
                                    title: "Simple Compliance — minimal filing requirements.",
                                },
                                {
                                    title: "Banking Options — eligible for offshore banks and PSPs.",
                                },
                                {
                                    title: "License Integration — can apply for forex, crypto, gaming, and banking licenses under MISA.",
                                },
                                {
                                    title: "Redomiciliation — easy to migrate in or out of Mwali.",
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "1 shareholder & 1 director (individual or corporate).",
                                },
                                {
                                    title: "No residency requirements.",
                                },
                                {
                                    title: "Company secretary not required.",
                                },
                                {
                                    title: "Local registered agent and address in Mwali.",
                                },
                                {
                                    title: "KYC documents (passport, proof of address, CV).",
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring — define company purpose & ownership.",
                                },
                                {
                                    title: "Name Reservation — ensure unique company name.",
                                },
                                {
                                    title: "Document Drafting — Memorandum & Articles of Association.",
                                },
                                {
                                    title: "Filing with MISA — submission to Mwali International Services Authority.",
                                },
                                {
                                    title: "Certificate of Incorporation issued.",
                                },
                                {
                                    title: "Optional Services — nominee directors, apostille, banking support.",
                                },
                            ]}
                        />

                        <h3 className='Timeline & Costs'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                { title: "Timeline: 3–7 business days." },
                                { title: "Setup Cost: from USD 2,000+." },
                                { title: "Annual Renewal: government license, agent, office, nominees if needed." },
                            ]}
                        />

                        <h3 className='page-title'>
                            Common Uses of Mwali IBC
                        </h3>
                        <PageList
                            items={[
                                { title: "Forex & brokerage back-office structure", icon: GoDotFill },
                                { title: "Crypto or fintech company with license add-ons", icon: GoDotFill },
                                { title: "iGaming & betting license holding company", icon: GoDotFill },
                                { title: "General trading & consulting", icon: GoDotFill },
                                { title: "Intellectual property & royalty holding", icon: GoDotFill },
                                { title: "Wealth planning & asset protection", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                { title: "Official Registered Agent with MISA.", icon: GoDotFill },
                                { title: "Fast incorporation & apostilled company packs.", icon: GoDotFill },
                                { title: "Expertise in license applications (forex, gaming, crypto, banking).", icon: GoDotFill },
                                { title: "Global network of banks, PSPs, and fintech providers.", icon: GoDotFill },
                                { title: "Comparative insights: Mwali vs Anjouan vs Western Sahara vs Seychelles.", icon: GoDotFill },
                            ]}
                        />


                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for an offshore company that supports licensing?"
                        description="A Mwali IBC offers low cost, fast incorporation, and license compatibility — perfect for forex, gaming, crypto, and fintech businesses."
                        buttonText="Book a Mwali IBC Consultation →"
                        buttonLink="/consultation"
                    />

                </div>

            </section>
        </main>
    )
}

export default MwaliIBC

const faqData = [
    {
        question: "How long does it take to form a Mwali IBC?",
        content: [
            { type: "answer", text: "3–7 business days." },
        ],
    },
    {
        question: "Is there a capital requirement?",
        content: [
            { type: "answer", text: "No — Mwali IBCs do not require minimum paid-up capital." },
        ],
    },
    {
        question: "Can one person own and run the company?",
        content: [
            { type: "answer", text: "Yes — single shareholder/director allowed." },
        ],
    },
    {
        question: "Does a Mwali IBC pay tax?",
        content: [
            { type: "answer", text: "No — not on offshore-sourced income." },
        ],
    },
    {
        question: "Can I use a Mwali IBC to apply for a license?",
        content: [
            {
                type: "answer",
                text: "Yes — Mwali IBCs are the base vehicle for <strong>forex, gaming, crypto, and banking licenses</strong>.",
            },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "Our forex business started with a Mwali IBC. Offshore Advisory made incorporation fast and simple.",
        author: "Karim A.",
        role: "Broker",
    },
    {
        quote:
            "We used a Mwali IBC for our crypto PSP. Offshore Advisory handled the full structure and compliance.",
        author: "Natalia  G.",
        role: "FinTech CEO",
    },
];